import { atomWithReset } from 'jotai/utils'

import { type DocumentImage } from './hooks/useFetchArchivedDocumentImages'

type DialogInfo = {
  dialogType: 'delete'
  documentImage: DocumentImage
}

export const dialogInfoAtom = atomWithReset<DialogInfo | undefined>(undefined)
